import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { GenderNameFromGenderIdPipe } from 'src/app/shared/pipes/gender-from-gender-id.pipe'
import { AgeFromBirthDatePipe } from 'src/app/shared/pipes/age-from-birth-date.pipe'
import { EntityFromIdPipe } from './entity-from-id.pipe'
import { GetPrimaryContactPipe } from './get-primary-contact.pipe'
import { SafePipe } from './safe.pipe'
import { TruncatePipe } from './truncate.pipe'
import { HoursToMinutesPipe, MinutesToHoursPipe, MsToHHMMPipe } from './timeconversion.pipe'
import { IMyDateModel } from '@nodro7/angular-mydatepicker'
import { RenderAssistanceRecurrenceInfoPipe } from '../../features/assistance/pipes/render-assistance-recurrence-info.pipe'
import { NamePipe } from '../../features/assistance/pipes/name.pipe'
import { MinutesToHhColonMmPipe } from './minutes-to-hh-colon-mm.pipe'
import { HoursToHhColonMmPipe } from './hours-to-hh-colon-mm.pipe'
import { SecondsToHhColonMmPipe } from './seconds-to-hh-colon-mm.pipe'
import { SortByPipe } from './sort-by.pipe'
import { ComputeRealizedDurationFromAssistancePipe } from '../../features/assistance/pipes/compute-realized-duration.pipe'
import { GenderIsMalePipe } from './gender-is-male.pipe'
import { GenderIsFemalePipe } from './gender-is-female.pipe'
import { IsAssistantActivePipe } from '../../features/assistant/pipes/is-assistant-active.pipe'
import { IsClientActivePipe } from '../../features/client/pipes/is-client-active'
import { FromOkSystemCodePipe } from './from-ok-system-code.pipe'
import { StripTagsPipe } from './stripHtml.pipe'
import { DateToTimeSegmentPipe } from './date-to-TimeSegment.pipe'
import { PlainTextFromHtmlPipe } from './plain-text-from-html.pipe'

@NgModule({
  declarations: [
    GenderNameFromGenderIdPipe,
    AgeFromBirthDatePipe,
    EntityFromIdPipe,
    GetPrimaryContactPipe,
    SafePipe,
    TruncatePipe,
    MinutesToHoursPipe,
    HoursToMinutesPipe,
    RenderAssistanceRecurrenceInfoPipe,
    NamePipe,
    MinutesToHhColonMmPipe,
    HoursToHhColonMmPipe,
    SortByPipe,
    ComputeRealizedDurationFromAssistancePipe,
    GenderIsMalePipe,
    GenderIsFemalePipe,
    IsAssistantActivePipe,
    IsClientActivePipe,
    FromOkSystemCodePipe,
    MsToHHMMPipe,
    StripTagsPipe,
    DateToTimeSegmentPipe,
    SecondsToHhColonMmPipe,
  ],
  imports: [CommonModule, PlainTextFromHtmlPipe],
  exports: [
    GenderNameFromGenderIdPipe,
    AgeFromBirthDatePipe,
    EntityFromIdPipe,
    GetPrimaryContactPipe,
    SafePipe,
    TruncatePipe,
    MinutesToHoursPipe,
    HoursToMinutesPipe,
    RenderAssistanceRecurrenceInfoPipe,
    NamePipe,
    MinutesToHhColonMmPipe,
    HoursToHhColonMmPipe,
    SortByPipe,
    ComputeRealizedDurationFromAssistancePipe,
    GenderIsMalePipe,
    GenderIsFemalePipe,
    IsAssistantActivePipe,
    IsClientActivePipe,
    FromOkSystemCodePipe,
    MsToHHMMPipe,
    StripTagsPipe,
    DateToTimeSegmentPipe,
    SecondsToHhColonMmPipe,
    PlainTextFromHtmlPipe,
  ],
})
export class PipesModule {
  public static convertAngularDatepickerOutputToTs(dpDate: IMyDateModel) {
    console.log('convertAngularDatepickerOutputToDate', dpDate)
    return dpDate.singleDate?.jsDate.getTime() ?? new Date(dpDate as unknown as number).getTime()
  }
}
